<app-data-table [configuration]="dataTableConfiguration"></app-data-table>
